export const forceDownloadFile = async (fileUrl: string) => {
    return new Promise<void>((resolve) => {
        const element = document.createElement("a");
        element.href = fileUrl;
        element.download = "";
        element.classList.add("sr-only");

        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);

        resolve();
    });
};
